module.exports = __webpack_public_path__ + "img/superiority_icon2.f4ad541.png";